import { render, staticRenderFns } from "./select-envelope-sender-id.vue?vue&type=template&id=6cd20d9e&scoped=true&"
import script from "./select-envelope-sender-id.vue?vue&type=script&lang=js&"
export * from "./select-envelope-sender-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd20d9e",
  null
  
)

export default component.exports